/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Response from escalation workflow start
 * @export
 * @interface EscalationResponse
 */
export interface EscalationResponse {
    /**
     * Temporal workflow ID for status queries and signals
     * @type {string}
     * @memberof EscalationResponse
     */
    workflowId?: string;
    /**
     * Whether the workflow was started successfully
     * @type {boolean}
     * @memberof EscalationResponse
     */
    success?: boolean;
    /**
     * Error message if success is false
     * @type {string}
     * @memberof EscalationResponse
     */
    error?: string;
}

/**
 * Check if a given object implements the EscalationResponse interface.
 */
export function instanceOfEscalationResponse(value: object): value is EscalationResponse {
    return true;
}

export function EscalationResponseFromJSON(json: any): EscalationResponse {
    return EscalationResponseFromJSONTyped(json, false);
}

export function EscalationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): EscalationResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'workflowId': json['workflowId'] == null ? undefined : json['workflowId'],
        'success': json['success'] == null ? undefined : json['success'],
        'error': json['error'] == null ? undefined : json['error'],
    };
}

export function EscalationResponseToJSON(json: any): EscalationResponse {
    return EscalationResponseToJSONTyped(json, false);
}

export function EscalationResponseToJSONTyped(value?: EscalationResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'workflowId': value['workflowId'],
        'success': value['success'],
        'error': value['error'],
    };
}

